import { NotFoundController } from './common/notfound-controller';
import { FootballController } from './football/home-controller';
import { GcoNameCorrectionController } from './gco/name-correction/name-correction-controller';

export const controllers = [NotFoundController,GcoNameCorrectionController, FootballController];
